/**
 * ContactForm.vue Startup File
 *
 * @project Codendot
 * @company Codendot <https://codendot.com>
 * @author Jawdat Sobh <jawdat@codendot.com>
 * @since Tuesday, November 4, 2025 at 02:14 PM GMT+2
 *
 */

import { createApp } from "@/lib/app"
import AppComponent from "../apps/ContactForm.vue"
import bootstrap from "../bootstrap/ContactForm"

const app = createApp("contactform", AppComponent)
bootstrap(app)
app.mount()
